/* eslint no-param-reassign: "error" */

export default [
  {
    id: 'lundi',
    content: `
    Monday, 11:55am. You're already thinking about lunch, salivating at the thought of your well-earned pasta salad.
    Your manager announces that Emily, one of the project leads from your team, will be absent this week.
    Your manager suggests that each member of the team take over part of her current workload of projects.
    Naturally, your manager will take a slightly larger share than everyone else.
    
    How do you react ?
    `,
    choices: ['tuile', 'mal', 'superman'],
  },
  {
    id: 'tuile',
    optionText: `« What a bother! …OK, I see how I can organize my week to concentrate on the important things
    and free up some time. How much time do you estimate will be needed for this task ? »`,
    content: `
    Such responsiveness! Not only do you suggest thoughtful time management solutions,
    but you even structure it around your availability! As a result, this change of schedule
    doesn't feel like being overloaded for you. You're off to a good start!
    However, always be careful to reassess priority across all tasks. Here you would need to revise your priorities,
    and evaluate the true level of priority for each of Emilie's projects to see where they fit.
    [See what the week brings next](@mercredi)
    `,
  },
  {
    id: 'mal',
    optionText: `« Ah, that's not great for me… I'll have a look at how much time I have left once
    I’m done with all my other tasks… I'll let you know maybe tomorrow or Wednesday… »`,
    content: `
    Your answer is a bit vague; to listen to you, anyone would think it's not your problem.
    
    Imagine you had another chance to put things right. What would you suggest ?
    `,
    choices: ['opendata', 'lune', 'retard'],
  },
  {
    id: 'opendata',
    optionText: `« I should mention, we're on the final straight of the OpenData project,
    I've got quite a lot to do still. »`,
    content: `
    That's a more concrete answer! Your team manager now has the information needed to understand
    your lack of availability and will be better able to adjust your workload.
    [See what the week brings next](@mercredi)
    `,
  },
  {
    id: 'lune',
    optionText: `« Actually, I can see that being a bit tricky… When would you be wanting those tasks back ?
    I don't want to promise you the moon and then be unable to stick to the timescales ! »`,
    content: `
    You exhibit a good deal of empathy, well done! Your efforts to put yourself
    in someone else’s shoes will certainly help to reassure them.
    [See what the week brings next](@mercredi)
    `,
  },
  {
    id: 'retard',
    optionText: `« Yes, you're right, I am a bit behind! I think if I pitch in with you,
    I'm going to make things worse. But you’ll get your own back another time ! »`,
    content: `
    Promising your manager they'll be able to get you back for something in the future might not be the best solution…
    At least you more or less admitted that you went a bit far.
    [See what the week brings next](@mercredi)
    `,
  },
  {
    id: 'superman',
    optionText: '« Say no more, I\'m on the case ! »',
    content: `
    Your enthusiasm is superhero-level, but be careful what you promise!
    Even if your manager takes a reasonable attitude,
    always think about your time management before making hasty promises! No-one wants you to get into difficulties.
    [See what the week brings next](@mercredi)
    `,
  },
]
